import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { theme as antdTheme } from 'antd';

import { apexThemeMode } from '@totem/components/services/optimize/v2/dashboard/chartUtils';

type Props = {
  totalEnergyCostSavings: number;
  totalDemandCostSavings: number;
  height?: number;
};

const SavingsMixDonut = ({
  totalEnergyCostSavings,
  totalDemandCostSavings,
  height = 280,
}: Props) => {
  const { useToken } = antdTheme;
  const { token } = useToken();

  const total = totalEnergyCostSavings + totalDemandCostSavings;
  const energyPct = total > 0 ? (totalEnergyCostSavings / total) * 100 : 0;
  const demandPct = total > 0 ? (totalDemandCostSavings / total) * 100 : 0;

  const formatCurrency = (val: number) =>
    `$${val.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

  const options: ApexCharts.ApexOptions = {
    chart: {
      type: 'donut',
      background: 'transparent',
    },
    theme: { mode: apexThemeMode(token.colorBgBase) },
    labels: [
      `Energy  ${energyPct.toFixed(0)}%`,
      `Demand  ${demandPct.toFixed(0)}%`,
    ],
    colors: ['#5B8FF9', '#F4A261'],
    legend: { position: 'bottom' },
    plotOptions: {
      pie: {
        donut: {
          size: '65%',
          labels: {
            show: true,
            total: {
              show: true,
              label: 'Total Savings',
              formatter: () => formatCurrency(total),
            },
          },
        },
      },
    },
    tooltip: {
      y: {
        formatter: (val: number) => formatCurrency(val),
      },
    },
    dataLabels: { enabled: false },
  };

  return (
    <ReactApexChart
      options={options}
      series={[totalEnergyCostSavings, totalDemandCostSavings]}
      type="donut"
      height={height}
    />
  );
};

export default SavingsMixDonut;
